export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/c58a79ed7dc2ca14963e3366521c8d07.png";